import 'regenerator-runtime/runtime'
import ky from 'ky-universal';
import localforage from 'localforage';
import _ from 'lodash';
const querystring = require('querystring');
const axios = require('axios');

/*
login
loginExternal

//Create a new user
signup
signupExternal
confirm --confirms the email/sms verification token

//Recover the user
requestPasswordRecovery
recover --confirms the email recovery token

verify --processes both confirm and recover

//Get current user/details/token
currentUser
getToken
getBalance

//
openCashierExternal --opens global iframe
openCashier --returns url for an iframe
*/

export default class Auth {

    constructor(options = {}) {
        /*this.name = "NETBET"
        this.jwt = ""
        this.bookmaker = options.bookmaker
        this.api = ky.extend({
            prefixUrl: 'https://staging-api.netbet.ie/',

        });*/
        this.sportify_api = ky.extend({
            prefixUrl: 'https://api.sportify.3fx.us/v1/',
        });
        this.store = localforage.createInstance({
            driver: localforage.LOCALSTORAGE,
            name: 'sportify',
            version: 1.0,
            storeName: 'auth',
            description: 'sportify auth'
        });
        /*this.balance = null;
        this.auth = {};

        this.instance = axios.create({
            baseURL: 'https://staging-api.netbet.ie/',
            timeout: 20 * 1000,
        });
        window.sendMessageToNetBet = this.sendMessageToNetBet;*/
    }

    /*sendMessageToNetBet(event, details) {
        const iframe = document.getElementById('netbet-iframe');
        if (iframe) {
            const target = iframe.contentWindow;
            target.postMessage(JSON.stringify({
                event: event,
                details: details,
                source: 'global.netbet',
            }));
        }
    }*/

    async getStoreItem(key) {
        let value = null;
        try {
            value = await this.store.getItem(key);
            console.log(value);
        } catch (err) {
            console.log(err);
        }

        return value

    }

    async getJWT() {
        return this.getStoreItem("sportsbook_token")
    }

    async storeToken(access_token) {
        if (!access_token) {
            this.store.removeItem("sportsbook_token");
        } else {
            this.store.setItem("sportsbook_token", access_token);
        }
    }

    /*async storeUser(details) {
        console.log('storeUser details', details);

        let auth = await this.getStoreItem("auth");
        console.log('storeUser auth', auth);
        if (auth == null)
            auth = {}
        auth = _.merge(auth, details);
        console.log('storeUser merge', auth);
        this.store.setItem("auth", auth);
        return auth;
    }

    async logout() {
        this.store.removeItem('auth');
        this.store.removeItem('jwt');
        this.store.removeItem('sportsbook_token');
    }

    async currentUser(force = false) {
        let auth = await this.getStoreItem("auth");
        console.log('updateUser', auth);
        if (!_.has(auth, 'username') && !_.has(auth, 'balance')) {
            return null;
        }
        auth = this._formatUser(auth);
        auth.balance = this.balance;
        return auth;
    }

    _formatUser(response) {

        let auth = {
            id: _.get(response, 'user_id'),
            name: _.get(response, 'username'),
            username: _.get(response, 'username'),
            email: _.get(response, 'email'),
            currency: _.get(response, 'currency'),
            balance: parseFloat(_.get(response, 'balance', 0)) * 100,
        }

        if (_.has(auth, 'username')) {
            return auth;
        }
        return null;
    }

    async getToken(force = false) {
        if (force) {
            let response = await this.api.post("refresh");
        }
        return "jwt";
    }

    async getBalance(force = true) {

        if (force) {
            let sportsbook_token = await this.getStoreItem('sportsbook_token');
            let sportsbook_response = await this.sportify_api.get("player/details", { headers: { 'jwt': sportsbook_token, 'bookmaker': this.bookmaker } }).json();
            console.log('sportsbook_response', sportsbook_response);
            this.balance = _.get(sportsbook_response, 'data.balance');
            return this.balance;
        }
        return this.balance;
    }
*/
    async getUser(force = true) {
        let sportsbook_token = await this.getStoreItem('sportsbook_token');
        let sportsbook_response = await this.sportify_api.get("player/details", { headers: { 'jwt': sportsbook_token, 'bookmaker': this.bookmaker } }).json();
        console.log('sportsbook_response', sportsbook_response);
        this.balance = _.get(sportsbook_response, 'data.balance');
        if( _.get(sportsbook_response, 'status'))
            return _.get(sportsbook_response, 'data');
        return false;
    }

}